var $8c375ce4d4f5e09f$exports = {};
!function(r) {
    "use strict";
    function n(r, n, e) {
        return e.a = r, e.f = n, e;
    }
    function F2(r) {
        return n(2, r, function(n) {
            return function(e) {
                return r(n, e);
            };
        });
    }
    function F3(r) {
        return n(3, r, function(n) {
            return function(e) {
                return function(t) {
                    return r(n, e, t);
                };
            };
        });
    }
    function F4(r) {
        return n(4, r, function(n) {
            return function(e) {
                return function(t) {
                    return function(u) {
                        return r(n, e, t, u);
                    };
                };
            };
        });
    }
    function F5(r) {
        return n(5, r, function(n) {
            return function(e) {
                return function(t) {
                    return function(u) {
                        return function(i) {
                            return r(n, e, t, u, i);
                        };
                    };
                };
            };
        });
    }
    function A2(r, n, e) {
        return 2 === r.a ? r.f(n, e) : r(n)(e);
    }
    function A3(r, n, e, t) {
        return 3 === r.a ? r.f(n, e, t) : r(n)(e)(t);
    }
    function A4(r, n, e, t, u) {
        return 4 === r.a ? r.f(n, e, t, u) : r(n)(e)(t)(u);
    }
    function A5(r, n, e, t, u, i) {
        return 5 === r.a ? r.f(n, e, t, u, i) : r(n)(e)(t)(u)(i);
    }
    function e(r, n, t) {
        if ("object" != typeof r) return r === n ? 0 : n > r ? -1 : 1;
        if (void 0 === r.$) return (t = e(r.a, n.a)) || (t = e(r.b, n.b)) ? t : e(r.c, n.c);
        for(; r.b && n.b && !(t = e(r.a, n.a)); r = r.b, n = n.b);
        return t || (r.b ? 1 : n.b ? -1 : 0);
    }
    function t(r, n) {
        return {
            a: r,
            b: n
        };
    }
    var u = {
        $: 0
    };
    function i(r, n) {
        return {
            $: 1,
            a: r,
            b: n
        };
    }
    var a = F2(i);
    function f(r) {
        for(var n = u, e = r.length; e--;)n = i(r[e], n);
        return n;
    }
    var o = F3(function(r, n, e) {
        for(var t = Array(r), u = 0; r > u; u++)t[u] = e(n + u);
        return t;
    }), c = F2(function(r, n) {
        for(var e = Array(r), u = 0; r > u && n.b; u++)e[u] = n.a, n = n.b;
        return e.length = u, t(e, n);
    });
    function v(r) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + r + ".md");
    }
    var s = Math.ceil, l = Math.floor, d = Math.log;
    function b(r) {
        return {
            $: 2,
            b: r
        };
    }
    b(function(r) {
        return "number" != typeof r ? x("an INT", r) : r > -2147483647 && 2147483647 > r && (0 | r) === r ? Fr(r) : !isFinite(r) || r % 1 ? x("an INT", r) : Fr(r);
    }), b(function(r) {
        return "boolean" == typeof r ? Fr(r) : x("a BOOL", r);
    }), b(function(r) {
        return "number" == typeof r ? Fr(r) : x("a FLOAT", r);
    }), b(function(r) {
        return Fr(r);
    });
    var h = b(function(r) {
        return "string" == typeof r ? Fr(r) : r instanceof String ? Fr(r + "") : x("a STRING", r);
    }), g = F2(function(r, n) {
        return p(r, n);
    });
    function p(r, n) {
        switch(r.$){
            case 2:
                return r.b(n);
            case 5:
                return null === n ? Fr(r.c) : x("null", n);
            case 3:
                return $(n) ? m(r.b, n, f) : x("a LIST", n);
            case 4:
                return $(n) ? m(r.b, n, y) : x("an ARRAY", n);
            case 6:
                var e = r.d;
                if ("object" != typeof n || null === n || !(e in n)) return x("an OBJECT with a field named `" + e + "`", n);
                var a = p(r.b, n[e]);
                return en(a) ? a : Er(A2(Lr, e, a.a));
            case 7:
                var o = r.e;
                return $(n) ? n.length > o ? (a = p(r.b, n[o]), en(a) ? a : Er(A2(Or, o, a.a))) : x("a LONGER array. Need index " + o + " but only see " + n.length + " entries", n) : x("an ARRAY", n);
            case 8:
                if ("object" != typeof n || null === n || $(n)) return x("an OBJECT", n);
                var c = u;
                for(var v in n)if (Object.prototype.hasOwnProperty.call(n, v)) {
                    if (a = p(r.b, n[v]), !en(a)) return Er(A2(Lr, v, a.a));
                    c = i(t(v, a.a), c);
                }
                return Fr(Rr(c));
            case 9:
                for(var s = r.f, l = r.g, d = 0; l.length > d; d++){
                    if (a = p(l[d], n), !en(a)) return a;
                    s = s(a.a);
                }
                return Fr(s);
            case 10:
                return a = p(r.b, n), en(a) ? p(r.h(a.a), n) : a;
            case 11:
                for(var b = u, h = r.g; h.b; h = h.b){
                    if (a = p(h.a, n), en(a)) return a;
                    b = i(a.a, b);
                }
                return Er(qr(Rr(b)));
            case 1:
                return Er(A2(Cr, r.a, n));
            case 0:
                return Fr(r.a);
        }
    }
    function m(r, n, e) {
        for(var t = n.length, u = Array(t), i = 0; t > i; i++){
            var a = p(r, n[i]);
            if (!en(a)) return Er(A2(Or, i, a.a));
            u[i] = a.a;
        }
        return Fr(e(u));
    }
    function $(r) {
        return Array.isArray(r) || "undefined" != typeof FileList && r instanceof FileList;
    }
    function y(r) {
        return A2(nn, r.length, function(n) {
            return r[n];
        });
    }
    function x(r, n) {
        return Er(A2(Cr, "Expecting " + r, n));
    }
    function w(r, n) {
        if (r === n) return !0;
        if (r.$ !== n.$) return !1;
        switch(r.$){
            case 0:
            case 1:
                return r.a === n.a;
            case 2:
                return r.b === n.b;
            case 5:
                return r.c === n.c;
            case 3:
            case 4:
            case 8:
                return w(r.b, n.b);
            case 6:
                return r.d === n.d && w(r.b, n.b);
            case 7:
                return r.e === n.e && w(r.b, n.b);
            case 9:
                return r.f === n.f && k(r.g, n.g);
            case 10:
                return r.h === n.h && w(r.b, n.b);
            case 11:
                return k(r.g, n.g);
        }
    }
    function k(r, n) {
        var e = r.length;
        if (e !== n.length) return !1;
        for(var t = 0; e > t; t++)if (!w(r[t], n[t])) return !1;
        return !0;
    }
    function A(r) {
        return r;
    }
    function j(r) {
        return {
            $: 0,
            a: r
        };
    }
    function _(r) {
        return {
            $: 2,
            b: r,
            c: null
        };
    }
    var N = F2(function(r, n) {
        return {
            $: 3,
            b: r,
            d: n
        };
    }), T = 0;
    function E(r) {
        var n = {
            $: 0,
            e: T++,
            f: r,
            g: null,
            h: []
        };
        return F(n), n;
    }
    function C(r, n) {
        r.h.push(n), F(r);
    }
    var L = !1, O = [];
    function F(r) {
        if (O.push(r), !L) {
            for(L = !0; r = O.shift();)q(r);
            L = !1;
        }
    }
    function q(r) {
        for(; r.f;){
            var n = r.f.$;
            if (0 === n || 1 === n) {
                for(; r.g && r.g.$ !== n;)r.g = r.g.i;
                if (!r.g) return;
                r.f = r.g.b(r.f.a), r.g = r.g.i;
            } else {
                if (2 === n) return void (r.f.c = r.f.b(function(n) {
                    r.f = n, F(r);
                }));
                if (5 === n) {
                    if (0 === r.h.length) return;
                    r.f = r.f.b(r.h.shift());
                } else r.g = {
                    $: 3 === n ? 0 : 1,
                    b: r.f.b,
                    i: r.g
                }, r.f = r.f.d;
            }
        }
    }
    var B = {};
    function R(r, n) {
        var e = {
            g: n,
            h: void 0
        }, t = r.c, u = r.d, i = r.e, a = r.f;
        function f(r) {
            return A2(N, f, {
                $: 5,
                b: function(n) {
                    var f = n.a;
                    return 0 === n.$ ? A3(u, e, f, r) : i && a ? A4(t, e, f.i, f.j, r) : A3(t, e, i ? f.i : f.j, r);
                }
            });
        }
        return e.h = E(A2(N, f, r.b));
    }
    var z = F2(function(r, n) {
        return _(function(e) {
            r.g(n), e(j(0));
        });
    });
    function D(r) {
        return function(n) {
            return {
                $: 1,
                k: r,
                l: n
            };
        };
    }
    var S = [], I = !1;
    function M(r, n, e) {
        if (S.push({
            p: r,
            q: n,
            r: e
        }), !I) {
            I = !0;
            for(var t; t = S.shift();)P(t.p, t.q, t.r);
            I = !1;
        }
    }
    function P(r, n, e) {
        var t = {};
        for(var i in G(!0, n, t, null), G(!1, e, t, null), r)C(r[i], {
            $: "fx",
            a: t[i] || {
                i: u,
                j: u
            }
        });
    }
    function G(r, n, e, t) {
        switch(n.$){
            case 1:
                var a = n.k, f = function(r, n, e, t) {
                    function u(r) {
                        for(var n = e; n; n = n.t)r = n.s(r);
                        return r;
                    }
                    return A2(r ? B[n].e : B[n].f, u, t);
                }(r, a, t, n.l);
                return void (e[a] = function(r, n, e) {
                    return e = e || {
                        i: u,
                        j: u
                    }, r ? e.i = i(n, e.i) : e.j = i(n, e.j), e;
                }(r, f, e[a]));
            case 2:
                for(var o = n.m; o.b; o = o.b)G(r, o.a, e, t);
                return;
            case 3:
                return void G(r, n.o, e, {
                    s: n.n,
                    t: t
                });
        }
    }
    function J(r) {
        B[r] && v(3);
    }
    var W = F2(function(r, n) {
        return n;
    });
    function Y(r) {
        var n = [], e = B[r].u, t = _(function(r) {
            var n = setTimeout(function() {
                r(j(0));
            }, 0);
            return function() {
                clearTimeout(n);
            };
        });
        return B[r].b = t, B[r].c = F3(function(r, u) {
            for(; u.b; u = u.b)for(var i = n, a = A(e(u.a)), f = 0; i.length > f; f++)i[f](a);
            return t;
        }), {
            subscribe: function(r) {
                n.push(r);
            },
            unsubscribe: function(r) {
                var e = (n = n.slice()).indexOf(r);
                0 > e || n.splice(e, 1);
            }
        };
    }
    var H = F2(function(r, n) {
        return function(e) {
            return r(n(e));
        };
    });
    var K = "undefined" != typeof document ? document : {};
    function Q(r, n) {
        r.appendChild(n);
    }
    function U(r) {
        return {
            $: 0,
            a: r
        };
    }
    var V = F2(function(r, n) {
        return F2(function(e, t) {
            for(var u = [], i = 0; t.b; t = t.b){
                var a = t.a;
                i += a.b || 0, u.push(a);
            }
            return i += u.length, {
                $: 1,
                c: n,
                d: er(e),
                e: u,
                f: r,
                b: i
            };
        });
    })(void 0);
    F2(function(r, n) {
        return F2(function(e, t) {
            for(var u = [], i = 0; t.b; t = t.b){
                var a = t.a;
                i += a.b.b || 0, u.push(a);
            }
            return i += u.length, {
                $: 2,
                c: n,
                d: er(e),
                e: u,
                f: r,
                b: i
            };
        });
    })(void 0);
    var X, Z = F2(function(r, n) {
        return {
            $: "a2",
            n: r,
            o: n
        };
    }), rr = F2(function(r, n) {
        return {
            $: "a3",
            n: r,
            o: n
        };
    }), nr = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;
    function er(r) {
        for(var n = {}; r.b; r = r.b){
            var e = r.a, t = e.$, u = e.n, i = e.o;
            if ("a2" !== t) {
                var a = n[t] || (n[t] = {});
                "a3" === t && "class" === u ? tr(a, u, i) : a[u] = i;
            } else "className" === u ? tr(n, u, A(i)) : n[u] = A(i);
        }
        return n;
    }
    function tr(r, n, e) {
        var t = r[n];
        r[n] = t ? t + " " + e : e;
    }
    function ur(r, n) {
        var e = r.$;
        if (5 === e) return ur(r.k || (r.k = r.m()), n);
        if (0 === e) return K.createTextNode(r.a);
        if (4 === e) {
            for(var t = r.k, u = r.j; 4 === t.$;)"object" != typeof u ? u = [
                u,
                t.j
            ] : u.push(t.j), t = t.k;
            var i = {
                j: u,
                p: n
            };
            return (a = ur(t, i)).elm_event_node_ref = i, a;
        }
        if (3 === e) return ir(a = r.h(r.g), n, r.d), a;
        var a = r.f ? K.createElementNS(r.f, r.c) : K.createElement(r.c);
        ir(a, n, r.d);
        for(var f = r.e, o = 0; f.length > o; o++)Q(a, ur(1 === e ? f[o] : f[o].b, n));
        return a;
    }
    function ir(r, n, e) {
        for(var t in e){
            var u = e[t];
            "a1" === t ? ar(r, u) : "a0" === t ? cr(r, n, u) : "a3" === t ? fr(r, u) : "a4" === t ? or(r, u) : ("value" !== t && "checked" !== t || r[t] !== u) && (r[t] = u);
        }
    }
    function ar(r, n) {
        var e = r.style;
        for(var t in n)e[t] = n[t];
    }
    function fr(r, n) {
        for(var e in n){
            var t = n[e];
            void 0 !== t ? r.setAttribute(e, t) : r.removeAttribute(e);
        }
    }
    function or(r, n) {
        for(var e in n){
            var t = n[e], u = t.f, i = t.o;
            void 0 !== i ? r.setAttributeNS(u, e, i) : r.removeAttributeNS(u, e);
        }
    }
    function cr(r, n, e) {
        var t = r.elmFs || (r.elmFs = {});
        for(var u in e){
            var i = e[u], a = t[u];
            if (i) {
                if (a) {
                    if (a.q.$ === i.$) {
                        a.q = i;
                        continue;
                    }
                    r.removeEventListener(u, a);
                }
                a = vr(n, i), r.addEventListener(u, a, X && {
                    passive: 2 > tn(i)
                }), t[u] = a;
            } else r.removeEventListener(u, a), t[u] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                X = !0;
            }
        }));
    } catch (r) {}
    function vr(r, n) {
        function e(n) {
            var t = e.q, u = p(t.a, n);
            if (en(u)) {
                for(var i, a = tn(t), f = u.a, o = a ? 3 > a ? f.a : f.o : f, c = 1 == a ? f.b : 3 == a && f.K, v = (c && n.stopPropagation(), (2 == a ? f.b : 3 == a && f.H) && n.preventDefault(), r); i = v.j;){
                    if ("function" == typeof i) o = i(o);
                    else for(var s = i.length; s--;)o = i[s](o);
                    v = v.p;
                }
                v(o, c);
            }
        }
        return e.q = n, e;
    }
    function sr(r, n) {
        return r.$ == n.$ && w(r.a, n.a);
    }
    function lr(r, n, e, t) {
        var u = {
            $: n,
            r: e,
            s: t,
            t: void 0,
            u: void 0
        };
        return r.push(u), u;
    }
    function dr(r, n, e, t) {
        if (r !== n) {
            var u = r.$, i = n.$;
            if (u !== i) {
                if (1 !== u || 2 !== i) return void lr(e, 0, t, n);
                n = function(r) {
                    for(var n = r.e, e = n.length, t = Array(e), u = 0; e > u; u++)t[u] = n[u].b;
                    return {
                        $: 1,
                        c: r.c,
                        d: r.d,
                        e: t,
                        f: r.f,
                        b: r.b
                    };
                }(n), i = 1;
            }
            switch(i){
                case 5:
                    for(var a = r.l, f = n.l, o = a.length, c = o === f.length; c && o--;)c = a[o] === f[o];
                    if (c) return void (n.k = r.k);
                    n.k = n.m();
                    var v = [];
                    return dr(r.k, n.k, v, 0), void (v.length > 0 && lr(e, 1, t, v));
                case 4:
                    for(var s = r.j, l = n.j, d = !1, b = r.k; 4 === b.$;)d = !0, "object" != typeof s ? s = [
                        s,
                        b.j
                    ] : s.push(b.j), b = b.k;
                    for(var h = n.k; 4 === h.$;)d = !0, "object" != typeof l ? l = [
                        l,
                        h.j
                    ] : l.push(h.j), h = h.k;
                    return d && s.length !== l.length ? void lr(e, 0, t, n) : ((d ? function(r, n) {
                        for(var e = 0; r.length > e; e++)if (r[e] !== n[e]) return !1;
                        return !0;
                    }(s, l) : s === l) || lr(e, 2, t, l), void dr(b, h, e, t + 1));
                case 0:
                    return void (r.a !== n.a && lr(e, 3, t, n.a));
                case 1:
                    return void br(r, n, e, t, gr);
                case 2:
                    return void br(r, n, e, t, pr);
                case 3:
                    if (r.h !== n.h) return void lr(e, 0, t, n);
                    var g = hr(r.d, n.d);
                    g && lr(e, 4, t, g);
                    var p = n.i(r.g, n.g);
                    return void (p && lr(e, 5, t, p));
            }
        }
    }
    function br(r, n, e, t, u) {
        if (r.c === n.c && r.f === n.f) {
            var i = hr(r.d, n.d);
            i && lr(e, 4, t, i), u(r, n, e, t);
        } else lr(e, 0, t, n);
    }
    function hr(r, n, e) {
        var t;
        for(var u in r)if ("a1" !== u && "a0" !== u && "a3" !== u && "a4" !== u) {
            if (u in n) {
                var i = r[u], a = n[u];
                i === a && "value" !== u && "checked" !== u || "a0" === e && sr(i, a) || ((t = t || {})[u] = a);
            } else (t = t || {})[u] = e ? "a1" === e ? "" : "a0" === e || "a3" === e ? void 0 : {
                f: r[u].f,
                o: void 0
            } : "string" == typeof r[u] ? "" : null;
        } else {
            var f = hr(r[u], n[u] || {}, u);
            f && ((t = t || {})[u] = f);
        }
        for(var o in n)o in r || ((t = t || {})[o] = n[o]);
        return t;
    }
    function gr(r, n, e, t) {
        var u = r.e, i = n.e, a = u.length, f = i.length;
        a > f ? lr(e, 6, t, {
            v: f,
            i: a - f
        }) : f > a && lr(e, 7, t, {
            v: a,
            e: i
        });
        for(var o = f > a ? a : f, c = 0; o > c; c++){
            var v = u[c];
            dr(v, i[c], e, ++t), t += v.b || 0;
        }
    }
    function pr(r, n, e, t) {
        for(var u = [], i = {}, a = [], f = r.e, o = n.e, c = f.length, v = o.length, s = 0, l = 0, d = t; c > s && v > l;){
            var b = (_ = f[s]).a, h = (N = o[l]).a, g = _.b, p = N.b, m = void 0, $ = void 0;
            if (b !== h) {
                var y = f[s + 1], x = o[l + 1];
                if (y) {
                    var w = y.a, k = y.b;
                    $ = h === w;
                }
                if (x) {
                    var A = x.a, j = x.b;
                    m = b === A;
                }
                if (m && $) dr(g, j, u, ++d), $r(i, u, b, p, l, a), d += g.b || 0, yr(i, u, b, k, ++d), d += k.b || 0, s += 2, l += 2;
                else if (m) d++, $r(i, u, h, p, l, a), dr(g, j, u, d), d += g.b || 0, s += 1, l += 2;
                else if ($) yr(i, u, b, g, ++d), d += g.b || 0, dr(k, p, u, ++d), d += k.b || 0, s += 2, l += 1;
                else {
                    if (!y || w !== A) break;
                    yr(i, u, b, g, ++d), $r(i, u, h, p, l, a), d += g.b || 0, dr(k, j, u, ++d), d += k.b || 0, s += 2, l += 2;
                }
            } else dr(g, p, u, ++d), d += g.b || 0, s++, l++;
        }
        for(; c > s;){
            var _;
            d++, yr(i, u, (_ = f[s]).a, g = _.b, d), d += g.b || 0, s++;
        }
        for(; v > l;){
            var N, T = T || [];
            $r(i, u, (N = o[l]).a, N.b, void 0, T), l++;
        }
        (u.length > 0 || a.length > 0 || T) && lr(e, 8, t, {
            w: u,
            x: a,
            y: T
        });
    }
    var mr = "_elmW6BL";
    function $r(r, n, e, t, u, i) {
        var a = r[e];
        if (!a) return i.push({
            r: u,
            A: a = {
                c: 0,
                z: t,
                r: u,
                s: void 0
            }
        }), void (r[e] = a);
        if (1 === a.c) {
            i.push({
                r: u,
                A: a
            }), a.c = 2;
            var f = [];
            return dr(a.z, t, f, a.r), a.r = u, void (a.s.s = {
                w: f,
                A: a
            });
        }
        $r(r, n, e + mr, t, u, i);
    }
    function yr(r, n, e, t, u) {
        var i = r[e];
        if (i) {
            if (0 === i.c) {
                i.c = 2;
                var a = [];
                return dr(t, i.z, a, u), void lr(n, 9, u, {
                    w: a,
                    A: i
                });
            }
            yr(r, n, e + mr, t, u);
        } else {
            var f = lr(n, 9, u, void 0);
            r[e] = {
                c: 1,
                z: t,
                r: u,
                s: f
            };
        }
    }
    function xr(r, n, e, t) {
        wr(r, n, e, 0, 0, n.b, t);
    }
    function wr(r, n, e, t, u, i, a) {
        for(var f = e[t], o = f.r; o === u;){
            var c = f.$;
            if (1 === c) xr(r, n.k, f.s, a);
            else if (8 === c) f.t = r, f.u = a, (v = f.s.w).length > 0 && wr(r, n, v, 0, u, i, a);
            else if (9 === c) {
                f.t = r, f.u = a;
                var v, s = f.s;
                s && (s.A.s = r, (v = s.w).length > 0 && wr(r, n, v, 0, u, i, a));
            } else f.t = r, f.u = a;
            if (!(f = e[++t]) || (o = f.r) > i) return t;
        }
        var l = n.$;
        if (4 === l) {
            for(var d = n.k; 4 === d.$;)d = d.k;
            return wr(r, d, e, t, u + 1, i, r.elm_event_node_ref);
        }
        for(var b = n.e, h = r.childNodes, g = 0; b.length > g; g++){
            u++;
            var p = 1 === l ? b[g] : b[g].b, m = u + (p.b || 0);
            if (!(u > o || o > m || (f = e[t = wr(h[g], p, e, t, u, m, a)]) && (o = f.r) <= i)) return t;
            u = m;
        }
        return t;
    }
    function kr(r, n) {
        for(var e = 0; n.length > e; e++){
            var t = n[e], u = t.t, i = Ar(u, t);
            u === r && (r = i);
        }
        return r;
    }
    function Ar(r, n) {
        switch(n.$){
            case 0:
                return function(r, n, e) {
                    var t = r.parentNode, u = ur(n, e);
                    return u.elm_event_node_ref || (u.elm_event_node_ref = r.elm_event_node_ref), t && u !== r && t.replaceChild(u, r), u;
                }(r, n.s, n.u);
            case 4:
                return ir(r, n.u, n.s), r;
            case 3:
                return r.replaceData(0, r.length, n.s), r;
            case 1:
                return kr(r, n.s);
            case 2:
                return r.elm_event_node_ref ? r.elm_event_node_ref.j = n.s : r.elm_event_node_ref = {
                    j: n.s,
                    p: n.u
                }, r;
            case 6:
                for(var e = n.s, t = 0; e.i > t; t++)r.removeChild(r.childNodes[e.v]);
                return r;
            case 7:
                for(var u = (e = n.s).e, i = r.childNodes[t = e.v]; u.length > t; t++)r.insertBefore(ur(u[t], n.u), i);
                return r;
            case 9:
                if (!(e = n.s)) return r.parentNode.removeChild(r), r;
                var a = e.A;
                return void 0 !== a.r && r.parentNode.removeChild(r), a.s = kr(r, e.w), r;
            case 8:
                return function(r, n) {
                    var e = n.s, t = function(r, n) {
                        if (r) {
                            for(var e = K.createDocumentFragment(), t = 0; r.length > t; t++){
                                var u = r[t].A;
                                Q(e, 2 === u.c ? u.s : ur(u.z, n.u));
                            }
                            return e;
                        }
                    }(e.y, n);
                    r = kr(r, e.w);
                    for(var u = e.x, i = 0; u.length > i; i++){
                        var a = u[i], f = a.A, o = 2 === f.c ? f.s : ur(f.z, n.u);
                        r.insertBefore(o, r.childNodes[a.r]);
                    }
                    return t && Q(r, t), r;
                }(r, n);
            case 5:
                return n.s(r);
            default:
                v(10);
        }
    }
    function jr(r) {
        if (3 === r.nodeType) return U(r.textContent);
        if (1 !== r.nodeType) return U("");
        for(var n = u, e = r.attributes, t = e.length; t--;){
            var a = e[t];
            n = i(A2(rr, a.name, a.value), n);
        }
        var f = r.tagName.toLowerCase(), o = u, c = r.childNodes;
        for(t = c.length; t--;)o = i(jr(c[t]), o);
        return A3(V, f, n, o);
    }
    var _r = F4(function(r, n, e, t) {
        return function(r, n, e, t, u, i) {
            var a = A2(g, r, n ? n.flags : void 0);
            en(a) || v(2);
            var f = {}, o = e(a.a), c = o.a, s = i(d, c), l = function(r, n) {
                var e;
                for(var t in B){
                    var u = B[t];
                    u.a && ((e = e || {})[t] = u.a(t, n)), r[t] = R(u, n);
                }
                return e;
            }(f, d);
            function d(r, n) {
                var e = A2(t, r, c);
                s(c = e.a, n), M(f, e.b, u(c));
            }
            return M(f, o.b, u(c)), l ? {
                ports: l
            } : {};
        }(n, t, r.au, r.aC, r.aA, function(n, e) {
            var u = r.aD, i = t.node, a = jr(i);
            return function(r, n) {
                n(r);
                var e = 0;
                function t() {
                    e = 1 === e ? 0 : (Nr(t), n(r), 1);
                }
                return function(u, i) {
                    r = u, i ? (n(r), 2 === e && (e = 1)) : (0 === e && Nr(t), e = 2);
                };
            }(e, function(r) {
                var e = u(r), t = function(r, n) {
                    var e = [];
                    return dr(r, n, e, 0), e;
                }(a, e);
                i = function(r, n, e, t) {
                    return 0 === e.length ? r : (xr(r, n, e, t), kr(r, e));
                }(i, a, t, n), a = e;
            });
        });
    }), Nr = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(r) {
        return setTimeout(r, 1e3 / 60);
    });
    "undefined" != typeof document && document, "undefined" != typeof window && window;
    var Tr = a, Er = function(r) {
        return {
            $: 1,
            a: r
        };
    }, Cr = F2(function(r, n) {
        return {
            $: 3,
            a: r,
            b: n
        };
    }), Lr = F2(function(r, n) {
        return {
            $: 0,
            a: r,
            b: n
        };
    }), Or = F2(function(r, n) {
        return {
            $: 1,
            a: r,
            b: n
        };
    }), Fr = function(r) {
        return {
            $: 0,
            a: r
        };
    }, qr = function(r) {
        return {
            $: 2,
            a: r
        };
    }, Br = F3(function(r, n, e) {
        for(;;){
            if (!e.b) return n;
            var t = e.b, u = r, i = A2(r, e.a, n);
            r = u, n = i, e = t;
        }
    }), Rr = function(r) {
        return A3(Br, Tr, u, r);
    }, zr = 32, Dr = F4(function(r, n, e, t) {
        return {
            $: 0,
            a: r,
            b: n,
            c: e,
            d: t
        };
    }), Sr = [], Ir = s, Mr = F2(function(r, n) {
        return d(n) / d(r);
    }), Pr = Ir(A2(Mr, 2, zr)), Gr = A4(Dr, 0, Pr, Sr, Sr), Jr = o, Wr = function(r) {
        return {
            $: 1,
            a: r
        };
    }, Yr = l, Hr = function(r) {
        return r.length;
    }, Kr = F2(function(r, n) {
        return e(r, n) > 0 ? r : n;
    }), Qr = function(r) {
        return {
            $: 0,
            a: r
        };
    }, Ur = c, Vr = F2(function(r, n) {
        for(;;){
            var e = A2(Ur, zr, r), t = e.b, u = A2(Tr, Qr(e.a), n);
            if (!t.b) return Rr(u);
            r = t, n = u;
        }
    }), Xr = F2(function(r, n) {
        for(;;){
            var e = Ir(n / zr);
            if (1 === e) return A2(Ur, zr, r).a;
            r = A2(Vr, r, u), n = e;
        }
    }), Zr = F2(function(r, n) {
        if (n.a) {
            var e = n.a * zr, t = Yr(A2(Mr, zr, e - 1)), u = r ? Rr(n.d) : n.d, i = A2(Xr, u, n.a);
            return A4(Dr, Hr(n.c) + e, A2(Kr, 5, t * Pr), i, n.c);
        }
        return A4(Dr, Hr(n.c), Pr, Sr, n.c);
    }), rn = F5(function(r, n, e, t, u) {
        for(;;){
            if (0 > n) return A2(Zr, !1, {
                d: t,
                a: e / zr | 0,
                c: u
            });
            var i = Wr(A3(Jr, zr, n, r));
            n -= zr, t = A2(Tr, i, t);
        }
    }), nn = F2(function(r, n) {
        if (r > 0) {
            var e = r % zr;
            return A5(rn, n, r - e - zr, r, u, A3(Jr, e, r - e, n));
        }
        return Gr;
    }), en = function(r) {
        return !r.$;
    }, tn = function(r) {
        switch(r.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, un = j, an = un(0), fn = F4(function(r, n, e, t) {
        if (t.b) {
            var u = t.a, i = t.b;
            if (i.b) {
                var a = i.a, f = i.b;
                if (f.b) {
                    var o = f.a, c = f.b;
                    if (c.b) {
                        var v = c.b;
                        return A2(r, u, A2(r, a, A2(r, o, A2(r, c.a, e > 500 ? A3(Br, r, n, Rr(v)) : A4(fn, r, n, e + 1, v)))));
                    }
                    return A2(r, u, A2(r, a, A2(r, o, n)));
                }
                return A2(r, u, A2(r, a, n));
            }
            return A2(r, u, n);
        }
        return n;
    }), on = F3(function(r, n, e) {
        return A4(fn, r, n, 0, e);
    }), cn = F2(function(r, n) {
        return A3(on, F2(function(n, e) {
            return A2(Tr, r(n), e);
        }), u, n);
    }), vn = N, sn = F2(function(r, n) {
        return A2(vn, function(n) {
            return un(r(n));
        }, n);
    }), ln = F3(function(r, n, e) {
        return A2(vn, function(n) {
            return A2(vn, function(e) {
                return un(A2(r, n, e));
            }, e);
        }, n);
    }), dn = z, bn = F2(function(r, n) {
        var e = n;
        return function(r) {
            return _(function(n) {
                n(j(E(r)));
            });
        }(A2(vn, dn(r), e));
    });
    B.Task = {
        b: an,
        c: F3(function(r, n) {
            var e;
            return A2(sn, function() {
                return 0;
            }, (e = A2(cn, bn(r), n), A3(on, ln(Tr), un(u), e)));
        }),
        d: F3(function() {
            return un(0);
        }),
        e: F2(function(r, n) {
            return A2(sn, r, n);
        }),
        f: undefined
    }, D("Task");
    var hn, gn, pn, mn, $n = _r, yn = {
        $: 2,
        m: u
    }, xn = function(r) {
        return {
            $: 1,
            a: r
        };
    }, wn = (gn = h, J(hn = "clipboardReceived"), B[hn] = {
        f: H,
        u: gn,
        a: function(r, n) {
            var e = u, t = B[r].u, i = j(null);
            return B[r].b = i, B[r].c = F3(function(r, n) {
                return e = n, i;
            }), {
                send: function(r) {
                    var u = A2(g, t, r);
                    en(u) || v(4);
                    for(var i = u.a, a = e; a.b; a = a.b)n(a.a(i));
                }
            };
        }
    }, D(hn)), kn = function(r) {
        return J(r), B[r] = {
            e: W,
            u: function() {
                return null;
            },
            a: Y
        }, D(r);
    }("requestClipboard"), An = F2(function(r, n) {
        return r.$ ? t(function(r, n) {
            var e = {};
            for(var t in r)e[t] = r[t];
            for(var t in n)e[t] = n[t];
            return e;
        }(n, {
            E: r.a
        }), yn) : t(n, kn(0));
    }), jn = function(r) {
        return r;
    }, _n = F2(function(r, n) {
        return A2(Z, r, jn(n));
    }), Nn = _n("className"), Tn = V("div"), En = V("h1"), Cn = V("hr"), Ln = V("img"), On = V("p"), Fn = U, qn = V("i"), Bn = V("span"), Rn = F4(function(r, n, e, t) {
        return A2(Tn, f([
            Nn("grid grid-cols-[2rem_1fr] gap-4")
        ]), f([
            A2(Tn, f([
                Nn("text-xl text-ink/80 text-right pt-[3px]")
            ]), f([
                A2(qn, f([
                    Nn(r)
                ]), u)
            ])),
            A2(Tn, u, f([
                A2(Tn, f([
                    Nn("border-b border-dotted border-ink/40 pb-[3px] flex justify-between items-baseline")
                ]), f([
                    A2(Bn, f([
                        Nn("text-lg font-medium")
                    ]), f([
                        Fn(n)
                    ]))
                ])),
                A2(Tn, f([
                    Nn("pl-1 pt-1 text-base italic text-ink/90")
                ]), f([
                    Fn(e)
                ])),
                "" !== t ? A2(Tn, f([
                    Nn("pl-1 text-sm text-ink/80")
                ]), f([
                    Fn(t)
                ])) : Fn("")
            ]))
        ]));
    });
    pn = {
        Main: {
            init: $n({
                au: function() {
                    return t({
                        E: ""
                    }, yn);
                },
                aA: function() {
                    return wn(xn);
                },
                aC: An,
                aD: function() {
                    var r, n;
                    return A2(Tn, f([
                        Nn("flex flex-col items-center min-h-screen text-center px-6 py-12 leading-relaxed")
                    ]), f([
                        A2(En, f([
                            Nn("text-4xl font-medium tracking-wide mb-8")
                        ]), f([
                            Fn("The Once Over")
                        ])),
                        A2(On, f([
                            Nn("text-base mb-10")
                        ]), f([
                            Fn("A nicer way to read")
                        ])),
                        A2(Tn, f([
                            Nn("my-8")
                        ]), f([
                            A2(Tn, f([
                                Nn("w-10 h-10 mx-auto")
                            ]), f([
                                A2(Ln, f([
                                    (r = "/logo.svg", A2(_n, "src", nr.test(n = r) ? "" : n))
                                ]), u)
                            ]))
                        ])),
                        A2(Cn, f([
                            Nn("w-full mb-8")
                        ]), u),
                        A2(En, f([
                            Nn("text-3xl font-medium tracking-wide mb-8 uppercase")
                        ]), f([
                            Fn("Contents")
                        ])),
                        A2(Tn, f([
                            Nn("max-w-lg space-y-8 text-left")
                        ]), f([
                            A4(Rn, "fa-solid fa-pen", "Input Text", "Write or paste your own words", "placeholder"),
                            A4(Rn, "fa-solid fa-book", "Browse the Library", "Discover beautifully formatted classics", "placeholder")
                        ]))
                    ]));
                }
            })((mn = {}, {
                $: 0,
                a: mn
            }))(0)
        }
    }, r.Elm ? function r(n, e) {
        for(var t in e)t in n ? "init" == t ? v(6) : r(n[t], e[t]) : n[t] = e[t];
    }(r.Elm, pn) : r.Elm = pn;
}($8c375ce4d4f5e09f$exports);


// Boot the Elm app
const $dad545c909cfec2d$var$app = (0, $8c375ce4d4f5e09f$exports.Elm).Main.init({
    node: document.getElementById("app"),
    flags: {}
});
$dad545c909cfec2d$var$app.ports.requestClipboard.subscribe(async function() {
    try {
        const text = await navigator.clipboard.readText();
        $dad545c909cfec2d$var$app.ports.clipboardReceived.send(text);
    } catch (err) {
        $dad545c909cfec2d$var$app.ports.clipboardReceived.send("[Error: unable to read clipboard]");
    }
});


//# sourceMappingURL=path0.d2386b1a.js.map
